import { config } from '../../../config';

const FROALA_KEY = config.REACT_APP_FROALA_KEY;

export const froalaConfiguration = {
  pluginsEnabled: [
    'align',
    'codeBeautifier',
    'codeView',
    'colors',
    'emoticons',
    'file',
    'fontAwesome',
    'fontFamily',
    'fontSize',
    'fullscreen',
    'image',
    'lineHeight',
    'lineBreaker',
    'link',
    'lists',
    'paragraphFormat',
    'paragraphStyle',
    'print',
    'quote',
    'specialCharacters',
    'table',
    'url',
    'video',
    'draggable',
  ],
  placeholderText: "Start typing or click the 'Add Research' button to import clips and highlight reels",
  key: FROALA_KEY,
  dragInline: false,
  videoDefaultDisplay: 'inline',
  videoResponsive: false,
  lineBreakerTags: ['span.fr-video'],
  charCounterCount: false,
  attribution: false,
  linkInsertButtons: ['linkBack'],
  zIndex: 10,
  tabSpaces: 4,
  toolbarButtons: {
    moreText: {
      buttons: [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'fontFamily',
        'fontSize',
        'textColor',
        'backgroundColor',
        'clearFormatting',
      ],
    },
    moreParagraph: {
      buttons: [
        'alignLeft',
        'alignCenter',
        'formatOLSimple',
        'alignRight',
        'alignJustify',
        'formatOL',
        'formatUL',
        'paragraphFormat',
        'paragraphStyle',
        'lineHeight',
        'outdent',
        'indent',
        'quote',
      ],
    },
    moreRich: {
      buttons: [
        'insertLink',
        'insertTable',
        'addResearch',
        'emoticons',
        'fontAwesome',
        'specialCharacters',
      ],
    },
    moreMisc: {
      buttons: [
        'undo',
        'redo',
        'fullscreen',
        'print',
        'spellChecker',
        'selectAll',
        'html',
        'help',
      ],
      align: 'right',
      buttonsVisible: 2,
    },
  },
};

// custom button
export const addResearchButton = `
<div style="font-family:roboto; font-size: 14px; border: 1px solid black; padding: 10px; border-radius: 3px;">
  Add Research
</div>
`;
